import { createFormInput, IFormInput, Rule } from "@lib/validate/form";

export interface IState {
    dataPolicyAccepted: IFormInput<boolean>
    dataPolicyError: boolean
    __datapolicy_checksum: string
    __datapolicy_type: string
    organizerAgreementAccepted: IFormInput<boolean>
    organizerAgreementError: boolean
    travellersError: boolean
    formSubmitted: boolean
}

export const initialState: IState = {
    dataPolicyAccepted: createFormInput<boolean>(false, false, Rule.truthy),
    dataPolicyError: false,
    __datapolicy_checksum: '',
    __datapolicy_type: '',
    organizerAgreementAccepted: createFormInput<boolean>(false, false, Rule.truthy),
    organizerAgreementError: false,
    travellersError: false,
    formSubmitted: false
};
